import * as React from 'react';
/**
 *
 * Original name: flash off
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=44410%3A37
 *
 */
export const FlashOffLine = (props) => (React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props },
    React.createElement("path", { d: "m17.142 10-1.535 1.535L11 17.129v-.987l-1.5 1.5v3.669L18.814 10h-1.672Z", fill: "currentColor", vectorEffect: "non-scaling-stroke" }),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "m5.44 19.581-1-1L9.02 14H5.186L14.5 2.695v5.826l4.081-4.082 1 1L5.44 19.581ZM13 6.875v3.146L10.52 12.5H8.365L13 6.875Z", fill: "currentColor", vectorEffect: "non-scaling-stroke" })));
